import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { DBUser } from "../../ostertalertypes";

interface IAutoCompleteUser
{
  onUserSelected: (value: DBUser | null) => void,
  selectedUser: DBUser | null,
  className?: string;
  users: DBUser[]
}

export const AutoCompleteUser: React.FC<IAutoCompleteUser> = (props) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<readonly DBUser[]>([]);
  const loading = open && options.length === 0;

  useEffect(() => {
      setOptions(props.users);
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const onSelection = (event: any, value: DBUser | null) => {
    props.onUserSelected(value);
  }

  function getDisplayName(user: DBUser) {
    return user.lastname + " " + user.firstname;
  }

  return (
        <Autocomplete
          onChange={onSelection}
          disableClearable={props.selectedUser !== null}
          className={"w-full " + props.className }
          id="userSearch"
          sx={{ width: 300 }}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          value={props.selectedUser}
          isOptionEqualToValue={(option, value) => option.userid === value.userid}
          getOptionLabel={(option) => getDisplayName(option)}
          options={options}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label = "Gast auswählen"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />);
}